'use client'

import React, { useEffect, useRef } from 'react'

export const ShareThis = () => {
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (divRef.current) {
      const html = document.createRange().createContextualFragment(`
      <span class="st_linkedin_large" displaytext="LinkedIn"></span>
      <span class="st_twitter_large" displaytext="Tweet"></span>
      <span class="st_facebook_large" displaytext="Facebook"></span>

      <script src="https://ws.sharethis.com/button/buttons.js"></script>

      <script>setTimeout(() => { if (stLight) { stLight.options({ publisher: "818b7c30-0f67-4541-a01b-83ad7af6829f", doNotHash: true, doNotCopy: true, hashAddressBar: false }) }}, 1000) </script>
      `)

      divRef.current.appendChild(html)
    }
  }, [])

  return <div ref={divRef}></div>
}
